import React, { useEffect } from "react";
import { connect } from "react-redux";
import {  Routes, Route } from "react-router-dom";
import PrivateRoute from "../PrivateRoute/PrivateRoute";
import { setAuthToken } from "../../utils";
import { setLoginUserInfo } from "../../actions/actions";
import { searchUser } from "../../actions/userProfileActions";

import PingIdLogin from "../PingIdLogin/PingIdLogin";
import SalesSummary from "../SalesSummary";
import SummaryDetails from "../SummaryDetails";
import LaborDetails from "../LaborDetails";
import ServicesDetails from "../ServicesDetails/ServicesDetails";
import InventoryControlDetails from "../InventoryControlDetails";
import OmniChannelDetails from "../OmniChannelDetails/OmniChannelDetails";
import {
  privacyPolicy as PrivacyPolicy,
  termsAndCondition as TermsAndCondition,
} from "../PrivacyTermsAndCondition";
import LogOut from "../LogOut/LogOut";
import PropTypes from "prop-types";

const PageNavigation = ({ setLoginUserInfo, searchUser }) => {
  useEffect(() => {
    const pingResponseRaw = localStorage.getItem("response");
    if (!pingResponseRaw) return;

    try {
      const tmpPingResponse = JSON.parse(pingResponseRaw);

      const employeeId =
        tmpPingResponse?.account?.idTokenClaims?.employeeId ?? null;
      const isCorpUser =
        tmpPingResponse?.account?.idTokenClaims?.isCorpUser ?? null;
      const accessToken = tmpPingResponse?.accessToken ?? null;

      if (accessToken && employeeId) {
        // Set token for API
        setAuthToken(accessToken, employeeId);
        // Trigger user search and set login info
        searchUser({ username: employeeId });
        setLoginUserInfo(tmpPingResponse);
        // Persist corp user flag as a string
        sessionStorage.setItem("isCorpUser", String(isCorpUser));
      }
    } catch (e) {
      // If parsing fails, ensure the bad entry doesn't brick the app
      console.error("Invalid response in localStorage:", e);
    }
  }, [setLoginUserInfo, searchUser]);

  return (
   
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<PingIdLogin />} />
        <Route path="/" element={<PingIdLogin />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndCondition />} />
        <Route path="/logout" element={<LogOut />} />

        {/* Protected routes group */}
        <Route element={<PrivateRoute />}>
          <Route path="/summary" element={<SalesSummary />} />
          <Route path="/sales-details/:tabId" element={<SummaryDetails />} />
          <Route path="/services-details/:tabId" element={<ServicesDetails />} />
          <Route path="/labor-details/:tabId" element={<LaborDetails />} />
          <Route
            path="/inventory-details/:tabId"
            element={<InventoryControlDetails />}
          />
          <Route
            path="/omnichannel-details/:tabId"
            element={<OmniChannelDetails />}
          />
        </Route>

        {/* Optional: catch-all 404 page */}
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
   
  );
};

PageNavigation.propTypes = {
  setLoginUserInfo: PropTypes.func.isRequired,
  searchUser: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  setLoginUserInfo: (data) => dispatch(setLoginUserInfo(data)),
  searchUser: (userData) => dispatch(searchUser(userData)),
});

export default connect(undefined, mapDispatchToProps)(PageNavigation);
